import React from 'react';

/**
 * Background Component
 * 
 * Renders the animated background effects including gradients, orbs, and grid patterns.
 * Optimized for performance using CSS transitions and absolute positioning.
 */
const Background = () => {
    return (
        <div className="fixed inset-0 z-[-1] overflow-hidden pointer-events-none">
            {/* Base Background */}
            <div className="absolute inset-0 bg-slate-50 dark:bg-[#0B1121] transition-colors duration-500"></div>

            {/* Gradient Orbs */}
            <div className="absolute top-[-10%] left-[-10%] w-[50%] h-[50%] rounded-full bg-purple-500/10 dark:bg-purple-600/20 blur-[120px] animate-blob mix-blend-multiply dark:mix-blend-screen"></div>
            <div className="absolute top-[20%] right-[-10%] w-[45%] h-[45%] rounded-full bg-indigo-500/10 dark:bg-indigo-600/20 blur-[120px] animate-blob mix-blend-multiply dark:mix-blend-screen" style={{ animationDelay: '2s' }}></div>
            <div className="absolute bottom-[-20%] left-[20%] w-[60%] h-[60%] rounded-full bg-pink-500/5 dark:bg-pink-600/10 blur-[150px] animate-blob mix-blend-multiply dark:mix-blend-screen" style={{ animationDelay: '4s' }}></div>

            {/* Grid Pattern */}
            <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20 dark:opacity-30 brightness-100 dark:brightness-100 contrast-150 mix-blend-overlay"></div>

            {/* Grid Lines */}
            <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:32px_32px]"></div>

            {/* Vignette */}
            <div className="absolute inset-0 bg-gradient-to-t from-slate-50 via-transparent to-slate-50/50 dark:from-slate-900/90 dark:via-transparent dark:to-slate-900/50"></div>
        </div>
    );
};

export default Background;
